

import { Suspense, useState } from 'react'

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease';
import { MdNotifications } from "react-icons/md"

import { Skeleton, Typography } from "@mui/material";
import NavBar from './NavBar';
import { Outlet } from 'react-router-dom';
import { RiLogoutCircleRLine } from 'react-icons/ri';
import { APP_CONSTANTS } from '../constants';

const drawerWidth = 280;
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
    open?: boolean;
}>(({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }),
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  }));
  
export function Layout() {

    const [open, setOpen] = useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const logout = () => {

        const keys = Object.keys(localStorage);
        keys.forEach((key) => {
            if (key.startsWith(APP_CONSTANTS.LOCALSTORAGE_PREFIX)) {
                localStorage.removeItem(key);
            }
        });

        window.location.pathname = APP_CONSTANTS.ROUTES.LOGIN;
    }

    return (
        <>

            <Box sx={{ display: 'flex' }}>

                <CssBaseline />
                <AppBar position="fixed" open={open}>
                    <Toolbar className="bg-white">
                        {!open ?
                            <IconButton onClick={handleDrawerOpen}
                            >
                                <MenuIcon />
                            </IconButton>
                            :
                            <IconButton onClick={handleDrawerClose} >

                                <FormatIndentDecreaseIcon />
                            </IconButton>
                        }
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>

                        </Typography>
                        <div className="flex gap-2 ">


                            <button type="button" className="relative inline-flex items-center p-3 text-sm font-medium text-center text-white ">
                                <MdNotifications color="#0B3954" size={30} >

                                </MdNotifications>
                                <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-[#0B3954] border-2 border-white rounded-full top-1 right-1 dark:border-gray-900">20</div>

                            </button>

                            <select id="countries" className="bg-gray-50  h-10 mt-2 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option selected>ADMIN</option>


                            </select>
                            <RiLogoutCircleRLine onClick={logout} color='red' size={60} className='cursor-pointer' />
                        </div>
                    </Toolbar>
                </AppBar>

               <NavBar onToggleDrawer={setOpen} isDrawerOpen={open}/>
               <Main open={open} className="bg-[#F6F8FD]">
                    <DrawerHeader />
                    <Suspense fallback={<Skeleton />}>
                        <Outlet />
                    </Suspense>

                </Main>
          
            </Box>

            
        </>
    );
}

export default Layout;
